
import { useState } from 'react';
import { ApiIndexFieldRepository } from '../../infrastructure/repositories/ApiIndexFieldRepository';
import { UpdateIndexField } from '../UseCase/UpdateIndexField'; 
import useApiClient from '../../infrastructure/apiClient';

export const useUpdateIndexField = () => {
    const[status,setstatus]=useState(false);
  const [error, setError] = useState(null);
  const apiClient = useApiClient();

  const UpdateIndexfield = async (UpdateIndexFieldRequest) => {

    const IndexfieldRepository = new ApiIndexFieldRepository(apiClient);
    const UpdateIndexfieldUseCase = new UpdateIndexField(IndexfieldRepository);

    try {
      console.log('I am in useUpdateIndexField hook '+JSON.stringify(UpdateIndexFieldRequest));
      const result = await UpdateIndexfieldUseCase.execute(UpdateIndexFieldRequest);
      setstatus(result);
      console.log('update index field response :'+result);
    } catch (err) {
      setError(err.message);
    }
  };

  return {status, UpdateIndexfield,error };
};
export default useUpdateIndexField;
